
class VideoTransitionManager {
    constructor(transitionVideosConfig) {
        this.transitionVideos = transitionVideosConfig.videos;
        this.transitions = transitionVideosConfig.transitions;
        this.container = null;
        this.transitionVideoElement = null;
        this.posterCanvas = null;
        this.posterCtx = null;
    }

    init(app, container) {
        const canvas = document.createElement("canvas");
        canvas.width = 1920;
        canvas.height = 1080;
        canvas.classList.add("transition-poster")
        container.appendChild(canvas);


        const video = document.createElement("video");
        video.classList.add("transition-video");
        video.setAttribute('webkit-playsinline', 'webkit-playsinline');
        video.setAttribute('playsinline', 'playsinline');
        video.muted = true;
        video.autoplay = false;
        container.appendChild(video);

        this.container = container;
        this.transitionVideoElement = video;
        this.posterCanvas = canvas;
        this.posterCtx = canvas.getContext("2d");

        // replace {root} with default route in transitions.
        this.transitions.map(o => {

            if (o.route.any)
                o.route.any = o.route.any.replace(/\{root\}/, app.defaultRoute);
            if (o.route.to)
                o.route.to = o.route.to.replace(/\{root\}/, app.defaultRoute);
            if (o.route.from)
                o.route.from = o.route.from.replace(/\{root\}/, app.defaultRoute);

            o.once = o.hasOwnProperty("once") ? o.once : false;
            o.timesPlayed = 0;
            o.guid = touchKit.utils.guid();
            return o;
        })

        app.radio.$on("router-change", ({ to, from }) => {
            this.onRouteChanged(to, from);
        })
    }

    getVideo(id) {
        const result = this.transitionVideos.find(o => o.id === id)
        if (!result) throw Error(`[VideoTransitionManager Error]  video "${id}" is not defined in the manifest: ${JSON.stringify(this.transitionVideos)}`)
        return result;
    }

    findTransitionsByRoutes(to, from) {

        // Matches a transition based on the route.
        const findTransitionDefinitions = (routeTo, routeFrom) => {
            return this.transitions.filter(t => {
                if ("any" in t.route) {
                    return t.route.any === routeTo || t.route.any === routeFrom;
                }
                else if ("to" in t.route && "from" in t.route) {
                    return t.route.to === routeTo && t.route.from === routeFrom;
                }
                return false;
            })
        }

        let outroTransitionId = null;
        let introTransitionId = null;

        // find all transitions that matches the to and from or both.
        const defs = findTransitionDefinitions(to, from);


        // filter the definitions for the best match 
        // defs that matches both to and from takes priority
        // if more then one is found we will use the first
        // and log an error.
        const verboseMatch = defs.find(d => {
            if ("to" in d.route && "from" in d.route) {
                return d.route.to === to && d.route.from === from;
            }
            return false;
        })
        const inMatch = defs.find(t => {
            if ("any" in t.route) {
                return t.route.any === to
            }
        })
        const outMatch = defs.find(t => {
            if ("any" in t.route) {
                return t.route.any === from;
            }
        })
        if (verboseMatch) {
            return {
                transitionIn:  { guid:verboseMatch.guid,  videoId: verboseMatch.video.any, once: verboseMatch.once, timesPlayed: verboseMatch.timesPlayed },
                transitionOut: { videoId: null }
            }
        }
        if (outMatch) outroTransitionId = { videoId: outMatch.video.out, once: outMatch.once, timesPlayed: outMatch.timesPlayed }
        if (inMatch) introTransitionId = { videoId: inMatch.video.in, once: inMatch.once, timesPlayed: inMatch.timesPlayed }
        return {
            transitionOut: { guid: outMatch? outMatch.guid : null, videoId: outMatch ? outMatch.video.out ? outMatch.video.out : null : null, once: outMatch ? outMatch.once : null, timesPlayed: outMatch ? outMatch.timesPlayed : null },
            transitionIn: { guid: inMatch? inMatch.guid : null, videoId: inMatch ? inMatch.video.in ? inMatch.video.in : null : null, once: inMatch ? inMatch.once : null, timesPlayed: inMatch ? inMatch.timesPlayed : null }
        }
    }

    set (uid, key,value) {
        var obj = this.transitions.find(o => o.guid === uid);
        if(obj) {
            obj[key] = value;
        }
    }

    onRouteChanged(to, from) {
        const fromRoute = from.path.replace(/:.*/, "");
        const toRoute = to.path.replace(/:.*/, "");
        // if content is opened we dont want to do the video transition.
        if(fromRoute === toRoute) return;
        const { transitionOut, transitionIn } = this.findTransitionsByRoutes(toRoute, fromRoute);
        const transitionSequence = [];
        const addVideoToSequence = (transition) => {
            if (transition.videoId) {
                const video = this.getVideo(transition.videoId)
                if (video) {
                    if (transition.once && transition.timesPlayed < 1) {
                       this.set(transition.guid, "timesPlayed", transition.timesPlayed+1)
                        transitionSequence.push(video);
                    } else if (!transition.once) {
                        this.set(transition.guid, "timesPlayed", transition.timesPlayed+1)
                        transitionSequence.push(video);
                    }
                }
            }
        }
        if (transitionOut.videoId) {
            addVideoToSequence(transitionOut)
        }
        if (transitionIn.videoId) {
            addVideoToSequence(transitionIn); 
        }
        if (transitionSequence.length) {
            this.play(transitionSequence);
        }else {
            app.radio.$emit("TransitionSequenceComplete");
        }
    }

    play(videos) {

        // send radio in ?
        var player = new TransitionSequence({ container: this.container, video: this.transitionVideoElement, ctx: this.posterCtx }, videos, () => {

            app.radio.$emit("TransitionSequenceComplete");
            // TODO: it should first hide the video when a scene-ready event have been received, then release the player (destroy and hide, clear canvas and reset video time.) 
            this.transitionVideoElement.classList.remove('transition-video--visible');

        });
        player.play();


    }
}


